import React from "react";
import PropTypes from "prop-types";
import Modal from "~components/Modal";
import { WarningIcon } from "~misc/icons";

const PriceSearchRequiredGroups = ({ isOpen, setIsOpen, grupos, handleConfirm }) => {
  const handleYes = (e) => {
    setIsOpen(false);
    handleConfirm(e);
  };

  const handleCancel = () => {
    setIsOpen(false);
  };

  return (
    <Modal
      isOpen={isOpen}
      sub={<Content grupos={grupos} />}
      buttonOne={"Sim"}
      buttonTwo={"Não"}
      onClose={handleCancel}
      linkOne={handleYes}
      linkTwo={handleCancel}
      className="price-search-client-share-modal"
    />
  );
};

PriceSearchRequiredGroups.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  grupos: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      nome: PropTypes.string.isRequired,
    })
  ),
  handleConfirm: PropTypes.func.isRequired,
};

const Content = ({ grupos }) => {
  return (
    <div className="content">
      <h3 className="title">
        <WarningIcon fill="red" width={30} height={30} />
        Aviso!
      </h3>

      {grupos?.length > 0 && (
        <>
          <p className="desc">Você não pesquisou nenhum dos seguintes produtos:</p>

          <div className="tag">
            {grupos?.map((grupo, index) => (
              <React.Fragment key={`${grupo.id || "group"}_${index}`}>
                {grupo.nome} <br />
              </React.Fragment>
            ))}
          </div>
        </>
      )}

      <p className="desc">O cliente realmente não trabalha com esses produtos?</p>
    </div>
  );
};

Content.propTypes = {
  grupos: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      nome: PropTypes.string.isRequired,
    })
  ),
};

PriceSearchRequiredGroups.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  grupos: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      nome: PropTypes.string.isRequired,
    })
  ).isRequired,
  handleConfirm: PropTypes.func.isRequired,
};

export default PriceSearchRequiredGroups;
